module.exports = __webpack_public_path__ + "img/Image Icon - white.eb312748.svg";